import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ page, pages, onPage }) {
  if (!pages || pages <= 1) return null;
  const nums = [];
  for (let i = 1; i <= pages; i++) {
    if (i === 1 || i === pages || Math.abs(i - page) <= 2) nums.push(i);
    else if (nums[nums.length - 1] !== "…") nums.push("…");
  }
  return (
    <div className="flex items-center justify-center gap-1.5 mt-10 flex-wrap" data-testid="pagination">
      <button disabled={page <= 1} onClick={() => onPage(page - 1)} className="p-2 rounded-lg border border-white/10 disabled:opacity-30 hover:bg-white/5" data-testid="page-prev"><ChevronLeft size={16} /></button>
      {nums.map((n, i) => n === "…"
        ? <span key={`e${i}`} className="px-2 text-zinc-600">…</span>
        : <button key={n} onClick={() => onPage(n)} data-testid={`page-${n}`}
            className={`min-w-[36px] h-9 rounded-lg text-sm font-medium ${n === page ? "bg-rose-500 text-white" : "border border-white/10 text-zinc-400 hover:text-white hover:bg-white/5"}`}>{n}</button>)}
      <button disabled={page >= pages} onClick={() => onPage(page + 1)} className="p-2 rounded-lg border border-white/10 disabled:opacity-30 hover:bg-white/5" data-testid="page-next"><ChevronRight size={16} /></button>
    </div>
  );
}
